// extracted by mini-css-extract-plugin
export var actions = "_3r-0";
export var actionsContainer = "_3r-6";
export var border = "_3r-1";
export var childFullHeight = "_3r-d";
export var collapse = "_3r-2";
export var content = "_3r-8";
export var contentChild = "_3r-c";
export var fullscreen = "_3r-a";
export var headerContainer = "_3r-3";
export var headerRow = "_3r-5";
export var hidePadding = "_3r-9";
export var noScrollX = "_3r-e";
export var noScrollY = "_3r-f";
export var optOutTopPadding = "_3r-b";
export var pagePadding = "_3r-7";
export var profile = "_3r-g";
export var profileContainer = "_3r-h";
export var profileImage = "_3r-i";
export var profileMain = "_3r-j";
export var profileSubtitle = "_3r-l";
export var profileTitle = "_3r-k";
export var tabsWrapper = "_3r-4";
export var title = "_3r-m";